import { render, staticRenderFns } from "./KusDocumentUnassociatedList.vue?vue&type=template&id=0f934d20"
import script from "./KusDocumentUnassociatedList.vue?vue&type=script&lang=js"
export * from "./KusDocumentUnassociatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports